import React from "react";

// SVG marker for Afval Halte, scaled to 7x12 px, original colors
const AfvalHalteMarkerSVG = ({ x, y }) => (
  <g transform={`translate(${x - 7.5}, ${y - 15})`}>
    <svg
      width={15}
      height={30}
      viewBox="0 0 283.46 708.66"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block" }}
    >
      <g>
        <rect y="425.2" width="283.46" height="283.46" fill="#1d1d1b" />
        <rect x="120.47" width="42.52" height="708.66" fill="#646363" />
      </g>
    </svg>
  </g>
);

export default AfvalHalteMarkerSVG;
